import type { ReleaseNotes } from "../releases";
import type { ApiConfiguration } from "./shared";

type Release = {
  ReleaseKey: string;
  ReleaseTitle: string;
  ReleaseDate: string;
  Content: string;
}

export const releaseNotesApi = (config: ApiConfiguration) => ({
  async getReleaseNotes(app: "care" | "portal"): Promise<ReleaseNotes | undefined> {
    const response = await config.cmsService.get<{
      PageTitle: string;
      PageSubtitle: string;
      TableOfContentsTitle: string;
      Releases: Release[];
    }>(config.cmsEndpoints[app === "care" ? "releaseNotesCare" : "releaseNotesPortal"]);

    const story = response.data.stories[0];
    if (!story) return undefined;

    return {
      pageTitle: story.content.PageTitle,
      pageSubtitle: story.content.PageSubtitle,
      tableOfContentsTitle: story.content.TableOfContentsTitle,
      releases: story.content.Releases.map((release: Release) => ({
        releaseKey: release.ReleaseKey,
        releaseTitle: release.ReleaseTitle,
        releaseDate: release.ReleaseDate,
        content: release.Content,
      })),
    };
  },
});
